import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Plans from "@/pages/Plans";
import About from "@/pages/About";
import Enquire from "@/pages/Enquire";
import GetCustomerID from "@/pages/GetCustomerID";
import CustomerLookup from "@/pages/CustomerLookup";
import RepairGallery from "@/pages/RepairGallery";
import Feedback from "@/pages/Feedback";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/about" element={<About />} />
              <Route path="/enquire" element={<Enquire />} />
              <Route path="/get-id" element={<GetCustomerID />} />
              <Route path="/lookup" element={<CustomerLookup />} />
              <Route path="/gallery" element={<RepairGallery />} />
              <Route path="/feedback" element={<Feedback />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </SmoothScroll>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#121417",
              border: "1px solid #27272A",
              color: "#F2F2F2",
              borderRadius: 0,
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "13px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
